// extracted by css-extract-rspack-plugin
export default {"JoinConditionRoot":"gqtoQ"};